import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { ErrorOutline } from "@material-ui/icons";
import _ from 'lodash';
import { getAllGuests, addGuestsToDeal } from "store/state/guest";
import { getAllGuestGroups } from "store/state/guestGroup";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Grid } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import {PrimaryButton, SecondaryButton} from 'components/Global/Buttons'
import styled from 'styled-components';
import TypeAheadDropdown from "components/Global/Fields/TypeAheadDropdown";
import { Divider, HeaderSection, SectionTitle } from "./styles";
import NewGuestTable from './NewGuestTable';


const localStyles = theme => ({
  dialogPaper: {
    'max-width':'925px',
    'font-size': '13px',    
    'height': '900px'
  },
  dialogTitle: {
    color: 'blue',
    padding: '0 0 0 20px'
  }
});

const HeaderContent = styled.div`
  &&&& {    
    font-family: "Roboto Medium", "Roboto Regular", Roboto;
    font-weight: 500;
    font-style: normal;
    font-size: 17px;
    color: rgb(153, 153, 153);
    width: 844px;
  }`;

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding-right: 60px;
    color: #666;
  }`;
const StyledFooterText = styled.div`
    font-family: "Roboto Medium", "Roboto Regular", Roboto;
    font-weight: 500;
    font-style: normal;
    font-size: 17px;    
    margin-left: 10px;
`;


const StyledErrorOutline = styled(ErrorOutline)`{
  color: red;
}`;

const StyledWrapper = styled.div`{
  position: relative;
  width: 31px;
  height: 37px;
  border: 2px #cccccc;}`;
const StyledLine = styled.div`{
  position: absolute;
  left: 49%;
  top: 0;
  bottom: 0;
  width: 1px;
  background: #cccccc;
  z-index: 1;}`;
const StyledWordwrapper = styled.div`{
  text-align: center;
  height: 12px;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  margin-top: -12px;
  z-index: 2;}`;
const StyledWord = styled.div`{
  color: #cccccc;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 3px;
  font: bold 12px arial,sans-serif;
  background: #fff;}`;

const selectStyles = {
  // control: (provided, state) => ({ ...provided, boxShadow: 'none', border:'none', padding: 0 }),
  // indicatorSeparator: (provided, state) => ({...provided, display:'none' }),
  container: (provided, state) => (
    {
      ...provided,
      borderBottom: '1px solid #2196F3',
      transition: 'border 0.1s',
      '&:hover': {
                  cursor: 'pointer',
                  borderBottom: '1px solid #21c1f2'
                },
      padding: '0',
      width: '300px'}),
}

class AddGuestModal extends React.Component {
  state = { selectedGroupId: null, selectedGuestId: null, guestGroups: [], guests: [], dealguests:[] }
  
  componentDidMount() {
    this.props.getAllGuests();
    this.props.getAllGuestGroups();
  };
  
  componentDidUpdate(prevProps, prevState) {
    if(this.props.modalOpen && !prevProps.modalOpen){
      
      const currentGuestList = this.props.currentGuestList;
      
      const transformedGuestGroups = this.props.guestGroups.map(item => ({ value: item.id, label: item.name }));

      let transformedGuests = [];
      this.props.guests.forEach(item => { 
        const existingGuest = currentGuestList.find(x => x.id === item.id);
        if(!existingGuest)
          transformedGuests.push({
            value: item.id, 
            label: `${item.contact.firstName} ${item.contact.lastName}` });
      });
      this.setState({guestGroups: _.sortBy(transformedGuestGroups, [(o) => o.label ]) , guests: transformedGuests});
    }    
  }
  
  handleChange(data, isGuest){
    let dealguestsCopy = this.state.dealguests.length > 0 ? this.state.dealguests : [];
    let order = dealguestsCopy.length > 0 ? dealguestsCopy.sort((a,b) => b.layoutOrder - a.layoutOrder)[0].layoutOrder : 0;
    let guestList = [];
    if(isGuest){
      const foundGuest = this.props.guests.find(x => x.id === data.value);
      if(foundGuest){
        order ++;
        guestList.push({layoutOrder: order,
                        id: foundGuest.id,
                        firstName: foundGuest.contact.firstName,
                        lastName: foundGuest.contact.lastName,
                        company: foundGuest.contact.company.name,
                        email: foundGuest.contact.email,
                        hasNoPermission: (this.props.isPortfolio && !foundGuest.portfolioPermission) ||
                                         (this.props.isPipeline && !foundGuest.pipelinePermission) 
                      });
      }
    } else {
      const currentGuestList = this.props.currentGuestList;
      const foundGuestGroup = this.props.guestGroups.find(x => x.id === data.value);
      if(foundGuestGroup){
       foundGuestGroup.guestgroups.forEach(foundGuest => { 
         const existingGuest = currentGuestList.find(x => x.id === foundGuest.id);
         if(!existingGuest) {
          order ++;
          guestList.push({layoutOrder: order,
                          id: foundGuest.id,
                          firstName: foundGuest.contact.firstName,
                          lastName: foundGuest.contact.lastName,
                          company: foundGuest.contact.company.name,
                          email: foundGuest.contact.email,
                          hasNoPermission: (this.props.isPortfolio && !foundGuest.portfolioPermission) ||
                                         (this.props.isPipeline && !foundGuest.pipelinePermission) 
                        });
          }

        });
      }
    }
    let merged = _(dealguestsCopy).keyBy('id').merge(_.keyBy(guestList, 'id')).values().value().sort((a,b) => b.layoutOrder - a.layoutOrder); 
    this.setState({
                    dealguests: merged,
                    selectedGroupId: null,
                    selectedGuestId: null
                  });
  }

  deleteGuest = (guest) => {
    let dealguestsCopy = this.state.dealguests.length > 0 ? this.state.dealguests : [];
    var updatedList = _.remove(dealguestsCopy, x =>  {
      return x.id !== guest.id;
    });

    this.setState({
      dealguests: updatedList,
      selectedGroupId: null,
      selectedGuestId: null
    });
   }

  closeModal =() => {
    this.setState({ selectedGroupId: null, selectedGuestId: null, dealguests:[]});
    this.props.closeModal();
  }

  sendInvite = () => {
    this.props.sendInvite(this.state.dealguests);
    this.closeModal();
  }

  render() {  
    let { classes } = this.props; 
    return (
      <Dialog  id="addGuestModal" open={this.props.modalOpen} onClose={this.closeModal}  fullWidth  maxWidth="md"  classes={{paper: classes.dialogPaper}} disableBackdropClick={true}>
          <DialogTitle>Invite to a Deal</DialogTitle>
          <StyledDialogIconButton onClick={this.closeModal}><CloseIcon id="closeIcon" style={{ fontSize: 22 }} /></StyledDialogIconButton>
          <StyledDialogContent>
            <Grid container alignItems="flex-start" justify="flex-start" direction="row" spacing={8}>
              <Grid item sm={12} md={12}>
                <HeaderContent>
                If you do not see the guest or guest group you are looking for, please contact your <a href={"mailto:support@loanboss.com"}>LoanBoss Administrator</a>.
                </HeaderContent>
                
              </Grid>
              <Grid item sm={5} md={5}>
              <TypeAheadDropdown
                    name="selectedGuestId"
                    selectStyles={selectStyles}
                    placeholder="Individual Guest"
                    value={this.state.selectedGuestId}
                    options={this.state.guests}
                    handleChange={data => this.handleChange(data, true)}
                    shouldShow={true}
                    usingFormik={false}
                  />
              </Grid>
              <Grid item sm={1} md={1}>
                <StyledWrapper>
                    <StyledLine/>
                    <StyledWordwrapper>
                        <StyledWord>OR</StyledWord>
                    </StyledWordwrapper>
                </StyledWrapper>

              </Grid>
              <Grid item sm={5} md={5}>
                <TypeAheadDropdown
                    name="selectedGroupId"
                    selectStyles={selectStyles}
                    placeholder="Guest Group"
                    value={this.state.selectedGroupId}
                    options={_.sortBy(this.state.guestGroups, [function(o) { return o.label; }])}
                    handleChange={data => this.handleChange(data, false)}
                    shouldShow={true}
                    usingFormik={false}
                  />
              </Grid>
            </Grid>
            <Fragment>
                <Divider>
                    <hr />
                </Divider>
                <HeaderSection container>
                    <Grid item xs={6} sm={6} md={6}>
                        <SectionTitle className="title-component">Invite List</SectionTitle>                        
                    </Grid>                 
                </HeaderSection>
                {" "}
            </Fragment>
            <Grid container alignItems="flex-start" justify="flex-start" direction="row">
              <Grid item>
                <NewGuestTable isPortfolio={true} records={this.state.dealguests} deleteGuest={this.deleteGuest}/>
              </Grid>
            </Grid>


          </StyledDialogContent>
          <Grid container>
              <Grid item>
                <StyledFooterText>
                  <StyledErrorOutline/> {" Indicates a guest with no permissions"}
                </StyledFooterText>
              </Grid>              
              <Grid item></Grid>
            </Grid>
            <DialogActions>
            
              
              <SecondaryButton id={"dialogNo"} onClick={this.closeModal}>Cancel</SecondaryButton>
              <PrimaryButton id="dialogYes" disabled={this.state.dealguests.length === 0} onClick={this.sendInvite}>Send Invite</PrimaryButton>
          </DialogActions>
        </Dialog>);
    };
  }

  const mapStateToProps = ({ authentication, guest, guestGroup }) => ({
    authentication,   
    guestGroups: guestGroup.guestGroups,
    guests: guest.guests
  });

  export default compose(
                  connect(mapStateToProps,{getAllGuests,addGuestsToDeal,getAllGuestGroups}),
                  withStyles(localStyles)
                 ) (AddGuestModal);
  